<template>
  <a-card size="small" title="迭代筛选">
    <a-form-model class="search-form" layout="inline">
      <a-form-model-item label="项目">
        <a-select v-model="filterForm.project_id" allow-clear placeholder="项目" style="width: 240px" @change="onProjectChange">
          <a-select-option v-for="project in projects" :key="project.id" :value="project.id">{{ project.name }} </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="迭代">
        <a-select v-model="filterForm.version_id" allow-clear placeholder="迭代" style="width: 240px" @change="onVersionChange">
          <a-select-option v-for="version in versions" :key="version.id" :value="version.id">{{ version.title }} </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import { versionList } from '@/api/project/version';
import { teamList } from '@/api/system/team';
import { projectList } from '@/api/project/project';

export default {
  name: 'VersionFilter',
  props: {
    filterForm: {
      type: Object,
      default: () => {
        return { version_id: null };
      }
    }
  },
  data() {
    return {
      labelCol: { span: 24 },
      wrapperCol: {},
      checkAll: true,
      plainOptions: [],
      versions: [],
      result: null,
      projects: [],
      selectedProjects: []
    };
  },
  mounted() {
    this.getVersionList();
    this.getProjectList();
  },
  methods: {
    onProjectChange() {
      this.getVersionList(this.filterForm.project_id);
    },
    getProjectList() {
      projectList({}).then(res => {
        this.projects = res.data.projects;
        this.filterForm.project_id = this.projects[0].id;
      });
    },
    onVersionChange(value) {
      this.filterForm.version_id = value;
      this.$emit('change', this.filterForm.version_id);
    },
    onSearch() {
      this.$emit('change');
    },

    // 获取项目列表
    getVersionList(projectId = 1) {
      versionList({ project_id: projectId }).then(res => {
        this.versions = res.data.list;
        this.filterForm.version_id = this.versions[0].id;
        this.$emit('change', this.filterForm.version_id);
      });
    },
    getTeamList() {
      teamList({ category: 1 }).then(res => {
        this.teams = res.data.items;
      });
    },
    handleChange(project_id, checked) {
      const { selectedProjects } = this;
      const nextSelectedProjects = checked ? [...selectedProjects, project_id] : selectedProjects.filter(t => t !== project_id);
      this.selectedProjects = nextSelectedProjects;
    }
  }
};
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0px;
  // border-bottom: silver 1px dashed;
}
</style>
